var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplace = function SvgReplace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6129032,6.76470588 C9.55979472,6.76470588 7.91788856,8.44803529 7.91788856,10.5529412 C7.91788856,12.6578471 9.55979472,14.3411765 11.6129032,14.3411765 C13.6660117,14.3411765 15.3079179,12.6578471 15.3079179,10.5529412 C15.3079179,8.44803529 13.6660117,6.76470588 11.6129032,6.76470588 L11.6129032,6.76470588 Z M11.6129032,4.6 C14.8072434,4.6 17.4193548,7.27801176 17.4193548,10.5529412 C17.4193548,13.8278706 14.8072434,16.5058824 11.6129032,16.5058824 C8.41856305,16.5058824 5.80645161,13.8278706 5.80645161,10.5529412 C5.80645161,7.27801176 8.41856305,4.6 11.6129032,4.6 L11.6129032,4.6 Z M8.4457478,0 L7.12609971,2.70588235 L1.84750733,2.70588235 C0.82398827,2.70588235 0,3.55065882 0,4.6 L0,16.5058824 C0,17.5552235 0.82398827,18.4 1.84750733,18.4 L21.3782991,18.4 C22.4018182,18.4 23.2258065,17.5552235 23.2258065,16.5058824 L23.2258065,4.6 C23.2258065,3.55065882 22.4018182,2.70588235 21.3782991,2.70588235 L16.0997067,2.70588235 L14.7800587,0 L8.4457478,0 Z",
    id: "replace-path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-2.7%",
    width: "108.6%",
    height: "110.9%",
    filterUnits: "objectBoundingBox",
    id: "replace-filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-223.000000, -233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#replace-path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#replace-path-1"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replace.f38b4b53.svg";
export { ForwardRef as ReactComponent };